import { render, staticRenderFns } from "./chinese_Culture_Video_Exhibition.vue?vue&type=template&id=4cea9e34&scoped=true"
import script from "./chinese_Culture_Video_Exhibition.vue?vue&type=script&lang=js"
export * from "./chinese_Culture_Video_Exhibition.vue?vue&type=script&lang=js"
import style0 from "./chinese_Culture_Video_Exhibition.vue?vue&type=style&index=0&id=4cea9e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea9e34",
  null
  
)

export default component.exports